<div class="error-container">
  <!-- <div class="error-danger error" (click)="closeError()">TEST</div> -->
</div>